var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden color-custom-dark-grey vh-100 bg-white"},[_c('router-view',{staticClass:"h-100"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }